import _startCase from 'lodash/startCase';
import {
  getCorrectAudioTrackLabel,
  AUDIO_TRACK,
  DISABLED_SUBTITLES,
  DISABLED_SUBTITLES_ID,
} from '@bedrock-rdk/media-engine';
import { t } from '../../../i18n';
import { ISO693_TO_1 } from '../../../../../lang/languageNames/ISO693-3to1.constants';
import { getClosedCaptionsLabel } from './customer/default/tracks.utils';

export const getLabelByLanguageCode = code => _startCase(t(`languages.${ISO693_TO_1[code] || code}`));

export const getAudioTrackLabelByLanguageCode = code => {
  switch (code) {
    case AUDIO_TRACK.AD:
      return t('player.audioDescription');
    case AUDIO_TRACK.OV:
      return t('player.originalSoundtrack');
    default:
      return getLabelByLanguageCode(code);
  }
};

export const getSubtitleTrackLabel = track => {
  if (!track) {
    return track.label;
  }

  if (track.language === DISABLED_SUBTITLES) {
    return t('player.subDisable');
  }

  const language = getLabelByLanguageCode(track.language);

  if (track.roles && track.roles.includes('caption')) {
    return getClosedCaptionsLabel(language);
  }

  return language;
};

export const getTracksWithCorrectLabel = tracks => {
  if (!tracks || !tracks.length) {
    return [];
  }

  return tracks.map(({ language, ...track }) => ({
    ...track,
    language,
    label: getCorrectAudioTrackLabel(language),
  }));
};

export const formatAudioTracks = tracks =>
  getTracksWithCorrectLabel(tracks).map(({ label, ...track }) => ({
    ...track,
    label: getAudioTrackLabelByLanguageCode(label),
  }));

export const formatSubtitlesTracks = tracks => {
  const tracksWithLabels = getTracksWithCorrectLabel(tracks);

  return [
    ...tracksWithLabels,
    {
      id: DISABLED_SUBTITLES_ID,
      active: !tracksWithLabels.some(({ active }) => active),
      language: DISABLED_SUBTITLES,
    },
  ].map(track => ({
    ...track,
    label: getSubtitleTrackLabel(track),
  }));
};

export const areForcedSubtitlesOnly = tracks =>
  tracks
    .filter(({ id }) => id !== DISABLED_SUBTITLES_ID)
    .every(({ roles }) => roles && roles.includes('forced_subtitle'));
